import { render, staticRenderFns } from "./ProductListItemLabelText.vue?vue&type=template&id=34932300"
import script from "./ProductListItemLabelText.vue?vue&type=script&lang=js"
export * from "./ProductListItemLabelText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports